import styled from '@emotion/styled'
import { Box, BoxProps } from '@chakra-ui/react'

const Row = styled(Box)<BoxProps>({ display: 'flex' })

Row.displayName = 'Row'

export default Row
